import React from 'react';
import { ErrorComponent } from './ErrorComponent';
export function NotFoundPage() {
    return (React.createElement(ErrorComponent, { iconVariant: "error", title: "Page Not Found", subtitle: "The page you're looking for doesn't exist or has been moved. You can go back to the dashboard or explore our forms.", ctaButtonProps: {
            text: "Go to Dashboard",
            href: window.location.origin,
        } }));
}
